// Browser tab titles for screens that set a header but no `title`, which would
// otherwise show their route name (e.g. "SecclOrderPreviewScreen")
const WEB_SCREEN_TITLES = {
    Pot: 'Pot',
    PotsActivity: 'Pot activity',
    EditPotGoal: 'Pot goal',
    PotInterestRates: 'Interest rates',
    InterestPotsFAQs: 'FAQs',
    AutosaveActivityTimeline: 'Autosave',
    DepositTimeline: 'Deposit',
    WithdrawTimeline: 'Withdrawal',
    CurrentAccountSwitchOffer: 'Switch current account',
    BroadBandQuotes: 'Broadband',
    BroadbandQuote: 'Broadband quote',
    PostCode: 'Postcode',
    EnergyQuotes: 'Energy',
    InformationLabel: 'Switching information',
    PersonalProjection: 'Personal projection',
    Quote: 'Quote',
    QuoteFurtherInformation: 'Quote information',
    SwitchCompleted: 'Switch completed',
    InvestPortfolio: 'Portfolio',
    InvestStock: 'Fund',
    InvestDiscover: 'Discover',
    InvestSearchStock: 'Search funds',
    InvestStaticCollectionDetails: 'Collection',
    InvestDiscoverCategorizationDetails: 'Discover',
    InvestCategoryFilterDetailsScreen: 'Discover',
    InvestStockNews: 'News',
    InvestFinancial: 'Financials',
    InvestAnalystRatingsDetails: 'Analyst ratings',
    InvestCorporateEvents: 'Corporate events',
    InvestFundAllocationDetail: 'Fund allocation',
    PerformanceExample: 'Performance example',
    FXInfoScreen: 'FX fees',
    InvestWatchList: 'Watch list',
    InvestCreateWatchList: 'New watch list',
    InvestStockAlertScreen: 'Price alerts',
    InvestSetStockAlertScreen: 'New price alert',
    InvestActivity: 'Activity',
    InvestNewActivityScreen: 'Activity',
    InvestInsights: 'Insights',
    StartInvestChooseAccount: 'Start investing',
    StartInvestChooseStrategy: 'Start investing',
    StartInvestReadyMadeFunds: 'Ready-made funds',
    Pdf: 'Document',
    DepositToTradingAccountTimeline: 'Deposit',
    DepositAndBuyAssetTimeline: 'Deposit and buy',
    WithdrawFromAccountTimeline: 'Withdrawal',
    AutoinvestManage: 'Autoinvest',
    AutoinvestActivities: 'Autoinvest activity',
    AutoinvestActivityTimeline: 'Autoinvest payment',
    ProductTransferProgress: 'Transfer',
    InvestBuyCustomAmount: 'Buy',
    SelectAssetFromPositions: 'Select a fund',
    BuyAssetForTradingAccount: 'Buy',
    SecclOrderPreviewScreen: 'Review order',
    InvestOrder: 'Order',
    BeforeYouSell: 'Before you sell',
    InvestSell: 'Sell',
    SelectAssetToSell: 'Select a fund to sell',
    SellAssetFromTradingAccount: 'Sell',
    InvestAssetSwitch: 'Switch',
    SecclAssetSwitchOrderPreview: 'Confirm your switch',
    InvestSwitchOrder: 'Switch order',
    InvestSwitchOrderDetails: 'Switch details',
    InvestOrders: 'Orders',
    InvestReceipt: 'Receipt',
    InvestSettings: 'Settings',
    PositionsInfo: 'Positions',
    BuyBlockScreen: 'Buying blocked',
    JISAChildDetails: 'Child details',
    ExportStatement: 'Export statement',
    ValuationStatement: 'Valuation statement',
    AnnualCostsAndCharges: 'Annual costs and charges',
    SelectCustomPeriodForStatements: 'Statement period',
};
export const getDocumentTitle = (options, routeName) => {
    const headerTitle = typeof options?.headerTitle === 'string' ? options.headerTitle : undefined;
    const title = (typeof options?.title === 'string' && options.title) ||
        headerTitle ||
        (routeName && WEB_SCREEN_TITLES[routeName]) ||
        routeName;
    return `${title} - Emma App`;
};
